/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetReportConsultationDto
 */
export interface GetReportConsultationDto {
    /**
     * 
     * @type {string}
     * @memberof GetReportConsultationDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetReportConsultationDto
     */
    userName: string;
    /**
     * 
     * @type {string}
     * @memberof GetReportConsultationDto
     */
    type?: GetReportConsultationDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetReportConsultationDto
     */
    healthcareFacilityName: string;
    /**
     * 
     * @type {number}
     * @memberof GetReportConsultationDto
     */
    countConsultations: number;
}


/**
 * @export
 */
export const GetReportConsultationDtoTypeEnum = {
    Neurological: 'Neurological',
    Ophthalmologist: 'Ophthalmologist',
    ENT: 'ENT',
    Psychiatric: 'Psychiatric'
} as const;
export type GetReportConsultationDtoTypeEnum = typeof GetReportConsultationDtoTypeEnum[keyof typeof GetReportConsultationDtoTypeEnum];


/**
 * Check if a given object implements the GetReportConsultationDto interface.
 */
export function instanceOfGetReportConsultationDto(value: object): value is GetReportConsultationDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('userName' in value) || value['userName'] === undefined) return false;
    if (!('healthcareFacilityName' in value) || value['healthcareFacilityName'] === undefined) return false;
    if (!('countConsultations' in value) || value['countConsultations'] === undefined) return false;
    return true;
}

export function GetReportConsultationDtoFromJSON(json: any): GetReportConsultationDto {
    return GetReportConsultationDtoFromJSONTyped(json, false);
}

export function GetReportConsultationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReportConsultationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'userName': json['userName'],
        'type': json['type'] == null ? undefined : json['type'],
        'healthcareFacilityName': json['healthcareFacilityName'],
        'countConsultations': json['countConsultations'],
    };
}

export function GetReportConsultationDtoToJSON(value?: GetReportConsultationDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'userName': value['userName'],
        'type': value['type'],
        'healthcareFacilityName': value['healthcareFacilityName'],
        'countConsultations': value['countConsultations'],
    };
}

